import React from 'react';
import { useLocation } from 'react-router-dom';
import BottomNavbar from './Menu';
import MobileBackButton from './MobileBackButton';


const NavbarWrapper = () => {
  const location = useLocation();

  // Check if we should show the back button
  const shouldShowBackButton = () => {
    const mainHomePaths = ["/", "/us", "/canada", "/mexico", "/uk"];
    return !mainHomePaths.includes(location.pathname);
  };

  return (
    <>
      <BottomNavbar />
      {shouldShowBackButton() && (
        <div className="d-md-none">
          <MobileBackButton />
        </div>
      )}
    </>
  );
};

export default NavbarWrapper;